import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Chip,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stepper,
  Step,
  StepLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  useTheme,
  alpha,
  Tabs,
  Tab,
} from '@mui/material';
import {
  Add as AddIcon,
  CheckCircle as ApproveIcon,
  Cancel as RejectIcon,
  Pending as PendingIcon,
  CalendarToday as CalendarIcon,
  BeachAccess as VacationIcon,
  LocalHospital as MedicalIcon,
  Work as WorkIcon,
} from '@mui/icons-material';

const Licencias = () => {
  const theme = useTheme();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);

  const licenciasData = [
    {
      id: 1,
      empleado: 'Carlos Mendoza',
      legajo: 'PL-004',
      tipo: 'Vacaciones',
      fechaInicio: '01/02/2026',
      fechaFin: '14/02/2026',
      dias: 14,
      estado: 'Aprobada',
      aprobador: 'Juan Supervisor',
    },
    {
      id: 2,
      empleado: 'María López',
      legajo: 'PL-003',
      tipo: 'Licencia Médica',
      fechaInicio: '28/01/2026',
      fechaFin: '04/02/2026',
      dias: 7,
      estado: 'Aprobada',
      aprobador: 'Sistema',
    },
    {
      id: 3,
      empleado: 'Pedro García',
      legajo: 'PL-002',
      tipo: 'Día Compensatorio',
      fechaInicio: '10/02/2026',
      fechaFin: '10/02/2026',
      dias: 1,
      estado: 'Pendiente',
      aprobador: '-',
    },
    {
      id: 4,
      empleado: 'Ana Martínez',
      legajo: 'PL-005',
      tipo: 'ART',
      fechaInicio: '15/01/2026',
      fechaFin: '25/01/2026',
      dias: 10,
      estado: 'Finalizada',
      aprobador: 'ART',
    },
    {
      id: 5,
      empleado: 'Roberto Sánchez',
      legajo: 'PL-006',
      tipo: 'Vacaciones',
      fechaInicio: '20/02/2026',
      fechaFin: '05/03/2026',
      dias: 14,
      estado: 'Pendiente',
      aprobador: '-',
    },
  ];

  const tipoIcon = (tipo) => {
    switch (tipo) {
      case 'Vacaciones': return <VacationIcon />;
      case 'Licencia Médica': return <MedicalIcon />;
      case 'ART': return <MedicalIcon />;
      default: return <WorkIcon />;
    }
  };

  const estadoConfig = (estado) => {
    switch (estado) {
      case 'Aprobada': return { color: 'success', icon: <ApproveIcon fontSize="small" /> };
      case 'Pendiente': return { color: 'warning', icon: <PendingIcon fontSize="small" /> };
      case 'Rechazada': return { color: 'error', icon: <RejectIcon fontSize="small" /> };
      case 'Finalizada': return { color: 'info', icon: <ApproveIcon fontSize="small" /> };
      default: return { color: 'default', icon: null };
    }
  };

  const resumenStats = [
    { label: 'En Licencia', value: 12, icon: <CalendarIcon />, color: theme.palette.info.main },
    { label: 'Vacaciones', value: 5, icon: <VacationIcon />, color: theme.palette.success.main },
    { label: 'Licencia Médica', value: 4, icon: <MedicalIcon />, color: theme.palette.warning.main },
    { label: 'ART', value: 3, icon: <MedicalIcon />, color: theme.palette.error.main },
  ];

  return (
    <Box className="fade-in">
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Typography variant="h4" fontWeight={700} color="primary">
            Gestión de Licencias
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Vacaciones, licencias médicas, ART y días compensatorios
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpenDialog(true)}>
          Nueva Solicitud
        </Button>
      </Box>

      {/* Resumen */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {resumenStats.map((stat, index) => (
          <Grid item xs={6} sm={3} key={index}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Avatar sx={{ bgcolor: alpha(stat.color, 0.1), color: stat.color }}>
                    {stat.icon}
                  </Avatar>
                  <Box>
                    <Typography variant="h4" fontWeight={700} color={stat.color}>
                      {stat.value}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {stat.label}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Tabs y Tabla */}
      <Card>
        <CardContent>
          <Tabs value={selectedTab} onChange={(e, v) => setSelectedTab(v)} sx={{ mb: 3 }}>
            <Tab label="Todas" />
            <Tab label="Pendientes (2)" />
            <Tab label="Aprobadas" />
            <Tab label="Finalizadas" />
          </Tabs>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
                  <TableCell>Empleado</TableCell>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Fecha Inicio</TableCell>
                  <TableCell>Fecha Fin</TableCell>
                  <TableCell align="center">Días</TableCell>
                  <TableCell>Estado</TableCell>
                  <TableCell>Aprobador</TableCell>
                  <TableCell align="center">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {licenciasData.map((row) => (
                  <TableRow key={row.id} hover>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ width: 32, height: 32, bgcolor: theme.palette.primary.main, fontSize: '0.75rem' }}>
                          {row.empleado.split(' ').map(n => n[0]).join('')}
                        </Avatar>
                        <Box>
                          <Typography variant="body2" fontWeight={500}>{row.empleado}</Typography>
                          <Typography variant="caption" color="text.secondary">{row.legajo}</Typography>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Chip
                        icon={tipoIcon(row.tipo)}
                        label={row.tipo}
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>{row.fechaInicio}</TableCell>
                    <TableCell>{row.fechaFin}</TableCell>
                    <TableCell align="center">
                      <Typography variant="body2" fontWeight={600}>{row.dias}</Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        icon={estadoConfig(row.estado).icon}
                        label={row.estado}
                        size="small"
                        color={estadoConfig(row.estado).color}
                      />
                    </TableCell>
                    <TableCell>{row.aprobador}</TableCell>
                    <TableCell align="center">
                      {row.estado === 'Pendiente' && (
                        <Box>
                          <IconButton size="small" color="success">
                            <ApproveIcon />
                          </IconButton>
                          <IconButton size="small" color="error">
                            <RejectIcon />
                          </IconButton>
                        </Box>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* Dialog Nueva Licencia */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Nueva Solicitud de Licencia</DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Empleado</InputLabel>
                <Select label="Empleado">
                  <MenuItem value="1">Juan Rodríguez - PL-001</MenuItem>
                  <MenuItem value="2">Pedro García - PL-002</MenuItem>
                  <MenuItem value="3">María López - PL-003</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Tipo de Licencia</InputLabel>
                <Select label="Tipo de Licencia">
                  <MenuItem value="vacaciones">Vacaciones</MenuItem>
                  <MenuItem value="medica">Licencia Médica</MenuItem>
                  <MenuItem value="art">ART</MenuItem>
                  <MenuItem value="compensatorio">Día Compensatorio</MenuItem>
                  <MenuItem value="estudio">Licencia por Estudio</MenuItem>
                  <MenuItem value="familiar">Licencia Familiar</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Fecha de Inicio"
                type="date"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Fecha de Fin"
                type="date"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Motivo / Observaciones"
                multiline
                rows={3}
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="outlined" component="label" fullWidth>
                Adjuntar Certificado
                <input type="file" hidden />
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={() => setOpenDialog(false)}>Cancelar</Button>
          <Button variant="contained" onClick={() => setOpenDialog(false)}>
            Enviar Solicitud
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Licencias;
